import Task from "../../../../core/model2/task/task"
import taskView_addTimeReport from "../../actions/add-time-report"
import taskView_startPauseTimer from "../../actions/start-timer"
import taskView_stopTimer from "../../actions/stop-timer"
import taskView_checkTimeReportAccess from "../../actions/check-time-report-access"

const debug = false
// const debug = "taskView_getTimerOptions"

export default function taskView_getTimerOptions(task: Task, hidePopover: func) {
    const onStartTimer = () => {
        hidePopover()

        debug && console.log(debug, 'onStartTimer', gd.company.license.isPro)

        if (!taskView_checkTimeReportAccess()) {
            return
        }

        taskView_startPauseTimer(task)
    }

    const onStopTimer = () => {
        debug && console.log(debug, 'onStopTimer')
        hidePopover()
        taskView_stopTimer(task)
    }

    const onResumeTimer = () => {
        debug && console.log(debug, 'onResumeTimer')
        hidePopover()
        gd.taskTimers.toggleTimer(task)
    }

    const onReportTime = () => {
        debug && console.log(debug, 'onReportTime')
        hidePopover()
        taskView_addTimeReport(task)
    }

    const timer = gd.taskTimers.getTimer(task.id);
    const timerActive = timer ? timer.isActive() : false;

    const options = []
    if (!timer) {
        options.push({
            icon    : 'i5-play-solid',
            label   : 'Start timer',
            onClick : onStartTimer
        })
    }

    if (timer && timerActive) {
        options.push({
            icon    : 'i5-stop-solid',
            label   : 'Stop timer',
            onClick : onStopTimer
        })
    }

    if (timer && !timerActive) {
        options.push({
            icon    : 'i5-play-solid',
            label   : 'Resume timer',
            onClick : onResumeTimer
        })
    }

    options.push({
        icon    : 'i5-time-reported',
        label   : 'Log time',
        onClick : onReportTime
    })

    return options
}